import styled from "styled-components";

export const Container = styled.div`
  padding-top: 5em;
`;
export const HeaderImage = styled.div`
  width: 100%;
  height: 10.1875rem;
  background: #bedfff;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    height: 8.0625rem;
  }
`;
export const Steps = styled.div`
  text-align: center;
  margin-left: -22em;
  margin-bottom: 1.25em;
  color: #3f3f3f;

  font-size: 0.8125rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;
export const Heading = styled.div`
  width: 4em;
  height: 4em;
  margin: 4em auto;
  border-radius: 50%;
  overflow: hidden;
`;
export const Card = styled.div`
  width: 22.375rem;
  border-radius: 0.375rem;
  background: #fff;
  box-shadow: 0px 0px 15px 0px rgba(217, 217, 217, 0.25);
  margin: 0em auto;
  margin-bottom: 4em;
  padding: 2em 2.19em;
  h1 {
    margin: 2em auto;
    margin-top: 0;
    text-align: center;
    color: #3f3f3f;

    font-size: 1.1875rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  .head {
    padding-bottom: 2.31em;
    border-bottom: 1px solid #e7e7e7;
  }

  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    padding: 2em 1.5em;
    width: 100%;
  }
`;
export const Checkout = styled.div`
  text-align: center;
  width: 18rem;
  height: 2.25rem;
  flex-shrink: 0;
  margin: 1em auto;
  border-radius: 0.25rem;
  background: #000;
  padding: 0.6em;
  color: #fff;

  font-size: 0.875rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  cursor: pointer;
  position: relative;
  input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 100%;
  }
`;
export const SubDiv = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0.8em auto;
  align-items: baseline;

  h2 {
    color: #3f3f3f;

    font-size: 0.875rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;
